import React, { useState } from 'react';

import Box from '@amzn/meridian/box';
import ConfirmModal from 'src/components/shared/confirmModal/confirmModal';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { setTaskGroupTableSettings } from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import {
  deleteTaskGroup,
  type TaskGroupTableDataRow,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import TaskGroupModal from './taskGroupModal/taskGroupModal';
import TaskGroupTable from './taskGroupTable/taskGroupTable';
import TopOptions from './topOptions/topOptions';

// **** Components **** //

/**
 * TaskGroup Configuration
 */
const TaskGroups = () => {
  const dispatch = useAppDispatch();
  const { isFetchTaskGroupsPending, taskGroupTableSettings } = useAppSelector((state) => state.taskConfigPage);
  const { currentPage, totalPages, perPage } = taskGroupTableSettings;
  const [taskGroupToDelete, setTaskGroupToDelete] = useState<TaskGroupTableDataRow | null>(null);

  // Open the "Confirm Delete" modal
  const onDeleteClick = (taskGroup: TaskGroupTableDataRow) => setTaskGroupToDelete(taskGroup);

  // Delete the task group
  const onConfirmDelete = async () => {
    if (taskGroupToDelete) {
      await dispatch(deleteTaskGroup(taskGroupToDelete.id));
      setTaskGroupToDelete(null);
    }
  };

  return (
    <Box className="view-and-edit-tasks">
      {/* Table */}
      <LoadingSpinnerWrapper showSpinner={isFetchTaskGroupsPending}>
        <TopOptions spacingInset="none none 400 none" />
        <TaskGroupTable onDeleteClick={onDeleteClick} />
        <PaginationWithDropdown
          currentPage={currentPage}
          totalPages={totalPages}
          perPage={perPage}
          setPerPage={(perPage) => dispatch(setTaskGroupTableSettings({ perPage }))}
          setCurrentPage={(currentPage) => dispatch(setTaskGroupTableSettings({ currentPage }))}
        />
      </LoadingSpinnerWrapper>

      {/* Modals */}
      <TaskGroupModal />
      <ConfirmModal
        open={!!taskGroupToDelete}
        setOpen={(open) => !open && setTaskGroupToDelete(null)}
        onConfirm={onConfirmDelete}
        modalTitle="Confirm Delete?"
        modalDescription={`Are you sure you want to delete ${taskGroupToDelete?.label}?`}
      />
    </Box>
  );
};

// **** Export **** //

export default TaskGroups;
